import { render, staticRenderFns } from "./FileLink.vue?vue&type=template&id=e5695964&scoped=true&"
import script from "./FileLink.vue?vue&type=script&lang=js&"
export * from "./FileLink.vue?vue&type=script&lang=js&"
import style0 from "./FileLink.vue?vue&type=style&index=0&id=e5695964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5695964",
  null
  
)

export default component.exports